import {ArrowDownOutlined, ArrowUpOutlined} from '@ant-design/icons';
import React from 'react';

interface TrendTagProps {
  value?: number;
  showPercent?: boolean;
}

const TrendTag: React.FC<TrendTagProps> = ({value = 0, showPercent = true}) => {
  if (value === 0) {
    return <span style={{color: '#999', fontSize: 12}}>持平</span>;
  }
  const isUp = value > 0;
  const color = isUp ? '#52c41a' : '#f5222d';
  const displayValue = showPercent
    ? `${(Math.abs(value) * 100).toFixed(1)}%`
    : Math.abs(value).toString();

  return (
    <span style={{color, fontSize: 12}}>
      {isUp ? <ArrowUpOutlined/> : <ArrowDownOutlined/>}
      {displayValue}
    </span>
  );
};

export default TrendTag;
